import { Calender, Home, Smile, User } from '../../../Assets/SVGS'
import './Two.css'
import CountUp from 'react-countup';
import { useInView } from 'react-intersection-observer';
import Icon from '../../common/Icon/Icon';
import { useTranslation } from 'react-i18next';
function Two(){
  const { t } = useTranslation();
  const { ref, inView } = useInView({
    triggerOnce: true, // يشتغل مرة واحدة بس
    threshold: 0.5,     // العنصر لازم يكون نصه ظاهر ع الأقل
  });

  return(
    <div className="two-container container"  ref={ref}>
      {inView&&<div className="two-content content">
        <div className="cards">
          <div className="card">
            <Icon icon={<Home width="30px"/>}/>
            <div>
              <h2>
                <CountUp
                  start={0}
                  end={3}
                >
                </CountUp>
              </h2>
              <p>{t('clinicRooms')}</p>
            </div>
          </div>
          <div className="card">
            <Icon icon={<User width="30px"/>}/>
            <div>
              <h2>
              <CountUp
                  start={0}
                  end={1}
                >
                </CountUp>
              </h2>
              <p>{t('specialistDoctor')}</p>
            </div>
          </div>
          <div className="card">
            <Icon icon={<Calender width="30px"/>}/>
            <div>
              <h2>
              <CountUp
                  start={0}
                  end={4379}
                >
                </CountUp>
              </h2>
              <p>{t('happyPatients')}</p>
            </div>
          </div>
          <div className="card">
            <Icon icon={<Smile width="30px"/>}/>
            <div>
              <h2>
              <CountUp
                  start={0}
                  end={10}
                >
                </CountUp>
              </h2>
              <p>{t('yearsOfExperience')}</p>
            </div>
          </div>
        </div>
      </div>}
    </div>
  )
}
export default Two